export default {
	UPDATE_SUPERADMIN: 'superadmin/update',
	SEND_GLOBAL_NOTIFICATION: 'superadmin/global-notification'
}